  $(".slick-slider-testi").slick({
   slidesToShow: 1,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000
     // dots: false, Boolean
    // arrows: false, Boolean
  });


// Image Slider Demo:
// https://codepen.io/vone8/pen/gOajmOo

  $(".slick-slider-post").slick({
   slidesToShow: 4,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
     // dots: false, Boolean
    // arrows: false, Boolean
            responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 3,
        }
      },      {
        breakpoint: 793,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]      
  });

  $(".slick-slider-customer-speak").slick({
   slidesToShow: 2,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
     // dots: false, Boolean
    // arrows: false, Boolean
                responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]  
  });

 $(".product-slider-custom").slick({
   slidesToShow: 4,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
     // dots: false, Boolean
    // arrows: false, Boolean
                responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
 
                  
    ]  
  });

 document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('.accordion details');

    accordions.forEach(detail => {
      detail.addEventListener('toggle', function() {
        if (detail.open) {
          // Close all other details
          accordions.forEach(otherDetail => {
            if (otherDetail !== detail) {
              otherDetail.removeAttribute('open');
            }
          });
        }
      });
    });
  });



  mobileOnlySlider(".custom-multicolumn .multicolumn-list", true, false, 1024);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider


mobileOnlySlider1(".shopify-section.image-text-column .image-text-row", true, false, 820);

function mobileOnlySlider1($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider


mobileOnlySlider2(".shopify-section.new-featured-collection .product-row", true, false, 820);

function mobileOnlySlider2($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

mobileOnlySlider3(".shopify-section.custom-banner .grid", true, false, 600);

function mobileOnlySlider3($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        centerMode: true,
        centerPadding: '0px',
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider
